import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="linkmanChangeRecords";

export let companyTypeEnum = {
  CUSTOMER_TYPE:1,
  COLLEAGUE_TYPE:2,
  OWNER_TYPE:3,
}

/*export function selectAll(parameter) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}*/
export function insert(parameter){
   console.log("data:",parameter)
   return axios({
     url: `/ws/${moduleName}`,
     method: 'post',
     data:parameter
   })
}

/*export function update(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'put',
    data:parameter
  })
}*/
/*export function selectOne(id) {
  console.log("id:", id)
  return axios({
    url: `/ws/${moduleName}/${id}`,
    method: 'get',
  })
}*/

export function queryByName(searchText,type) {
  return axios({
    url: `/ws/${moduleName}/queryByName/${searchText}/${type}`,
    method: 'get',
  })
}
export function queryByKey(key) {
  return axios({
    url: `/ws/${moduleName}/queryByKey/${key}`,
    method: 'get',
  })
}

export function queryByLinkmanId(id) {
  console.log("id:", id)
  return axios({
    url: `/ws/${moduleName}/queryByLinkmanId/${id}`,
    method: 'get',
  })
}

export default {
  companyTypeEnum,
  insert,
  queryByLinkmanId,
  queryByName,
  queryByKey,
 // update,
 // selectAll,
 // selectOne
}